<template>
  <div>
    <!-- marco principal de la aplicación cabecera datos conexion y usuario -->
    <v-toolbar fixed app color="primaryToolbar">
      <v-toolbar-side-icon class="hidden-md-and-up" @click="showMenuResp"></v-toolbar-side-icon>

      <v-toolbar-title class="ml-0">
        <img flat small alt="" :src="stylePath + '/img/logo.png'" width="auto"
          max-width="140" height="56" class="pt-2">
      </v-toolbar-title>

      <v-toolbar-items class="pl-4 hidden-sm-and-down">
        <v-btn v-for="menu in menuPrincipal" :id="'menu_' + menu.id" :key="menu.codigo" :class="getMenuClass(menu)"
          class="my-0 fill-height" flat @click="loadMenu(menu)">{{ menu.title }}</v-btn>
      </v-toolbar-items>
      <v-spacer></v-spacer>

      <v-flex shrink class="companyName" :class="$vuetify.breakpoint.xs ? 'pr-0' : 'pr-2'">
        <p class="mb-0">{{ nombreEmpresa }}</p>
        <span>{{ dLoggedUser }}</span>
      </v-flex>

      <v-menu open-on-hover bottom offset-y content-class="languageList">
        <v-btn flat slot="activator" class="languageListBtn mx-0 hidden-sm-and-down " icon>
          <span></span> {{ languageSelected }}
        </v-btn>
        <v-list>
          <v-list-tile v-for="(item, index) in languages" :key="index">
            <v-list-tile-title class="" @click="fChangeLanguage(item.value)">
              <p>{{ item.text }}</p>
            </v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>


      <!-- cabecera con selector de empresa -->
      <shp-seleccion-empresa :moduloApp="modulo" class="hidden-md-and-down"></shp-seleccion-empresa>

      <!-- selector de cliente -->
      <shp-seleccion-cliente :moduloApp="modulo" class="hidden-md-and-down"></shp-seleccion-cliente>
      <!-- carrito -->
      <!-- desconexion de la plataforma -->

      <v-btn flat icon class="closeSesionBtn hidden-sm-and-down" @click="alertaDesconexion();">
        <v-icon class="datPrimaryColor">mdi-power</v-icon>
      </v-btn>
    </v-toolbar>

    <v-flex v-show="dMenuRepsonsive" class="menuResponsive pa-4">
      <v-layout row wrap justify-space-between align-center class="mb-4">
        <v-flex xs6>
          <v-img :src="stylePath + '/img/logo.png'" contain></v-img>
        </v-flex>
        <v-flex xs6 text-xs-right>
          <v-btn flat icon class="ma-0" @click="showMenuResp">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex xs9 class="companyName">
          <p class="mb-0">{{ nombreEmpresa }}</p>
          <span>{{ dLoggedUser }}</span>
        </v-flex>
      </v-layout>

      <!-- cabecera con selector de empresa -->
      <v-divider color="grey" class="my-4"></v-divider>
      <v-flex>
        <v-list>
          <v-list-tile :class="getMenuClassResponsive(menu)" v-for="(menu, index) in menuPrincipal" :key="index">
            <v-list-tile-content>
              <v-list-tile-title :id="menu.id" v-html="menu.title" @click="loadMenu(menu)"></v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-flex>
      <v-divider color="grey" class="mt-2 mb-4"></v-divider>
      <v-flex class="">
        <v-btn class="datPrimaryBtnOut" block flat @click="alertaDesconexion();">
          <v-icon>mdi-power</v-icon>
          {{ this.$t('cerrarSesion') }}
          <!-- Cerrar sesión -->
        </v-btn>
      </v-flex>
    </v-flex>
    <!-- alerta desconexion -->
    <v-dialog v-model="mostrarAlertaDesconexion" persistent max-width="400">
      <v-card>
        <v-flex text-xs-center>
          <v-icon class="pt-4 logOutIcon">mdi-login-variant</v-icon>
        </v-flex>
        <v-card-text class="alertText px-4 py-3 text-xs-center">{{ $t('deseaDesconectar') }}</v-card-text>
        <v-card-actions class="pb-4 justify-center transparent">
          <v-btn class="datPrimaryBtnOut" flat @click="mostrarAlertaDesconexion = false">{{ $t('no') }}</v-btn>
          <v-btn class="datPrimaryBtn" flat @click="desconectar();">{{ $t('si') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- comprobacion borrado -->
    <v-dialog v-model="mostrarAvisos" persistent max-width="400">
      <v-card class="data-aviso">
        <v-card-title class="subheading">
          <v-flex xs12>
            <v-icon large>error_outline</v-icon>
          </v-flex>
          <v-flex xs12>
            <span v-html="textAviso"></span>
          </v-flex>
        </v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="datPrimaryBtn" @click="mostrarAvisos = false">{{ this.$t('cerrar') }}</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>

// Servicios
import SrvUsers from '@/services/srv-users'

import ShpSeleccionEmpresa from '@/components/Informes/Base/ShpSeleccionEmpresa'
import ShpSeleccionCliente from '@/components/Catalogo/ShpSeleccionCliente'
import SrvAdmUsuarios from '@/services/srv-adm-usuarios.js'

export default {
  name: 'ShpApp',
  components: {
    ShpSeleccionEmpresa,
    ShpSeleccionCliente,
    SrvAdmUsuarios
  },

  data() {
    return {
      dMenuRepsonsive: false,
      search: '',
      modulo: this.$store.getters.getModulo,
      icons: ['fab fa-facebook', 'fab fa-twitter', 'fab fa-google-plus', 'fab fa-linkedin', 'fab fa-instagram'],
      selectedMenu: this.modulo,
      opcionesPortal: [],
      menuPrincipalBase: [
        { id: 1, codigo: 'CATALOGO', title: this.$t('catalogo'), url: '/catalogo', visible: false },
        { id: 2, codigo: 'TIENDA', title: this.$t('tienda'), url: '/tienda', visible: false },
        { id: 3, codigo: 'PRESUPUESTOS', title: this.$t('presupuestos'), url: '/presupuestos', visible: false },
        { id: 4, codigo: 'INFORMES', title: this.$t('informes'), url: '/informes', visible: false },
        { id: 5, codigo: 'ADMIN_USU', title: this.$t('administracionUsuarios'), url: '/administracion/usuarios', visible: false }
      ],
      dEventoAlerta: 'evento-mostrarAvisos',
      menuPrincipal: [],
      mostrarAlertaDesconexion: false,
      presupuesto: null,
      origen: '',
      mostrarAvisos: false,
      textAviso: '',
      dLoggedUser: '',
      languageSelected: this.$i18n.locale,
      languages: [
        { text: 'Español', value: 'es' },
        { text: 'English', value: 'en' },
        { text: 'Français', value: 'fr' },
        { text: 'Italiano', value: 'it' },
        
      ]
    }
  },
  created() {
    /*
     * Evento para mostrar avisos generales
     */
    this.$bus.$on(this.dEventoAlerta, (textoAviso) => {
      this.mostrarAvisos = true
      this.textAviso = textoAviso
    })
  },
  mounted() {
    setTimeout(() => {
      if (this.$store.getters.getAuthPortal !== undefined && this.$store.getters.getAuthPortal !== null && this.$store.getters.getAuthPortal.usuario !== null && this.$store.getters.getAuthPortal.usuario !== '') {
        this.dLoggedUser = this.$store.getters.getAuthPortal.usuario
      }
      if (this.$store.getters.getAutenticacion !== undefined && this.$store.getters.getAutenticacion !== null && this.$store.getters.getAutenticacion.usuario !== null && this.$store.getters.getAutenticacion.usuario !== '') {
        this.dLoggedUser = this.$store.getters.getAutenticacion.usuario
      }
      // Carga los Modulos que puede ver un usuario
      if (this.dLoggedUser !== null) {
        this.cargaOpcionesPortal();
      }
      if (this.languageSelected !== this.$i18n.locale) {
        this.fChangeLanguage(this.$i18n.locale);
      }
    }, 1000);
    // 
  },
  beforeDestroy() {
    /*
     * evento cargas aviosgenerales
     */
    this.$bus.$off(this.dEventoAlerta)
  },
  computed: {
    cTextLoading() {
      return this.pTextLoading
    }
  },
  methods: {
    showMenuResp() {
      this.dMenuRepsonsive = !this.dMenuRepsonsive
    },
    /*
     * muestra las imagenes de producto
     */
    loadMenu(menu) {
      // Establece el nuevo modulo
      this.$store.commit('setModulo', menu.codigo)
      this.modulo = this.$store.getters.getModulo

      // actualiza la opcion de menu
      this.selectedMenu = this.modulo

      // actualiza las opciones de la cabecera
      this.muestraSeleccionEmpresa = (this.modulo === 'PRESUPUESTOS')

      // enruta la nueva opcion de menu
      this.$router.push(menu.url)
      this.dMenuRepsonsive = false
    },
    /*
     * Evento para lanzar la carga de datos
     */
    cargaOpcionesPortal() {
      // prepara los parametros generales de busqueda
      if (this.idOrganizacion === null) {
        setTimeout(() => {
          const idOrganizacion = (this.$store.getters.getUrlInfo.organizacion !== null) ? this.$store.getters.getUrlInfo.organizacion : this.$store.getters.getAutenticacion.organizacion
          const jsonEntrada = {
            idOrganizacion: idOrganizacion
          }

          SrvUsers.listaOpcionesPortal(jsonEntrada).then(response => {
            if (response.data.statusCode === '200') {
              const datosOpcionesPortal = response.data
              this.opcionesPortal = datosOpcionesPortal.result
              this.chequeaOpcionesPortal()
              this.cargaDefaultMenu()
            } else {
              this.$bus.$emit(this.dEventoAlerta, '<b>carga las opciones de portal</b><br> ' + response.data.statusText + '  (' + response.data.statusCode + ' ) ')
            }
          }).catch(error => {
            this.$bus.$emit(this.dEventoAlerta, '<b>carga las opciones de portal</b><br> ' + error.response.data.statusText)
          })
        }, 2000)
      } else {
        const jsonEntrada = {
          idOrganizacion: this.idOrganizacion
        }

        SrvUsers.listaOpcionesPortal(jsonEntrada).then(response => {
          if (response.data.statusCode === '200') {
            const datosOpcionesPortal = response.data
            this.opcionesPortal = datosOpcionesPortal.result
            this.chequeaOpcionesPortal()
            this.cargaDefaultMenu()
          } else {
            this.$bus.$emit(this.dEventoAlerta, '<b>carga las opciones de portal</b><br> ' + response.data.statusText + '  (' + response.data.statusCode + ' ) ')
          }
        }).catch(error => {
          this.$bus.$emit(this.dEventoAlerta, '<b>carga las opciones de portal</b><br> ' + error.response.data.statusText)
        })
      }
    },
    /*
     * Comprueba las opciones que puede ver
     */
    chequeaOpcionesPortal() {
      // prepara los parametros generales de busqueda
      this.menuPrincipal = []
      for (let i = 0; i < this.menuPrincipalBase.length; i++) {
        this.menuPrincipalBase[i].value = false
        for (let j = 0; j < this.opcionesPortal.length; j++) {
          if (this.menuPrincipalBase[i].id === this.opcionesPortal[j].id) {
            this.menuPrincipal.push(this.menuPrincipalBase[i])
            break
          }
        }
      }
    },
    /*
     * Comprueba las opciones que puede ver
     */
    cargaDefaultMenu() {
      let loadDefaultMenu = false
      // Actualiza el menu seleccionado por defecto
      this.modulo = this.$store.getters.getModulo
      if (this.modulo === undefined) {
        this.modulo = this.process.env.DEFAULT_MODULE
      }
      for (let i = 0; i < this.menuPrincipal.length; i++) {
        const menu = this.menuPrincipal[i]
        if (menu.codigo === this.modulo) {
          for (let j = 0; j < this.opcionesPortal.length; j++) {
            if (this.menuPrincipal[i].id === this.opcionesPortal[j].id) {
              this.selectedMenu = menu.codigo
              loadDefaultMenu = true
              this.loadMenu(menu)
              break
            }
          }
        }
      }
      if (!loadDefaultMenu) {
        for (let i = 0; i < this.menuPrincipal.length; i++) {
          const menu = this.menuPrincipal[i]
          if (this.menuPrincipal[i].id === this.opcionesPortal[0].id) {
            this.selectedMenu = menu.codigo
            this.loadMenu(menu)
            break
          }
        }
      }
    },
    fChangeLanguage(language) {
      this.languageSelected = language
      this.$i18n.locale = language;
      this.$store.commit('removeOrderStatus');
      const payload = {
        idioma: language,
        usuario: this.$store.getters.getAuthPortal.usuario
      }
      SrvAdmUsuarios.changeUserLanguage(payload).then(response => {
        const datosPortal = this.$store.getters.getAuthPortal
        datosPortal.idiomaUsuario = language
        this.$store.commit('setAutenticacionPortal', datosPortal)
        location.reload();
      })

    },
    /*
     * muestra las imagenes de producto
     */
    getImagen(productos) {
      return productos.imagen
    },
    /*
    /*
     * muestra la alerta de desconexion
     */
    alertaDesconexion() {
      this.mostrarAlertaDesconexion = true
    },
    /*
     * realiza la desconexion y vuelve a la pagina de registro
     */
    desconectar() {
      this.mostrarAlertaDesconexion = false
      // Limpia la cache
      this.$store.commit('removeAutenticacion')

      // redirige a la pagina de login
      this.$router.push('/')
    },
    /*
     * cambia el estilo del menu
     */
    getMenuClass(menu) {
      return (menu.codigo === this.selectedMenu) ? 'toolbarLinksSelect' : 'toolbarLinks'
    },
    getMenuClassResponsive(menu) {
      return (menu.codigo === this.selectedMenu) ? 'menuLinksSelect' : 'menuLinks'
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/ShpHeaderApp.vue